const workingPapers = [
        {
        title: 'What Does Congregate Supportive Housing Do? Evidence from Linked Administrative Data',
        authors: 'Pierre-Loup Beauregard, Victor Couture,  Jeffrey Hicks, David MacDonald, Ingrid Monsivais Ibarra',
        date: 'Ongoing'
    },
    {
        title: 'Pathways Into Homelessness',
        authors: 'Pierre-Loup Beauregard, Victor Couture, David Green, Jeffrey Hicks, William Warburton',
        date: 'July 2026',
        abstract: 'We investigate the determinants of homelessness by documenting complete life trajectories leading to a first spell. We use a panel of linked administrative records from healthcare, criminal justice, education, and social assistance for the full population of British Columbia. Future homeless individuals face severe disadvantage beginning in childhood: over half had contact with child welfare services, and fewer than a quarter graduated from high school. In the months before onset, emergency room visits, mental health and substance use treatment, and alleged crime rise sharply. These rich histories identify a high-risk group whose rate of first entry into homelessness, out of sample, is 25 percent over the following year, roughly 80 times the population rate. A handful of risk factors, capturing substance use, criminal justice involvement, and poverty, identify this group almost as well as the full model. These findings offer the most comprehensive picture to date of the risk factors for homelessness, and show that entry is predictable from data collected at points of contact with government services.',
        links: [
            {
            title: 'Paper',
            url: 'https://www.dropbox.com/scl/fi/wkrdb9lgdbsbrx3ymrme5/BCGHW_homelessness_currentPublic.pdf?rlkey=ezxy51uh1qmfiev3l69rs5mlc&st=fij66s0w&raw=1'
            }
        ]
    },
    {
        title: 'The Effects of Field Office Closures on Social Assistance Take-up and Targeting',
        authors: 'Jeffrey Hicks',
        date: 'August 2025, First version May 2024',
        journal: 'Revise & Resubmit, Labour Economics',
        abstract: 'How does in-person support affect access to safety net programs? I study this question by examining how the closure of field offices has changed welfare and disability assistance caseloads. Using rich administrative data and a staggered difference-in-differences design, I estimate that closures, on average, reduced local caseloads by 11.5% for welfare and a statistically insignificant 1.6% for disability assistance. Declines in welfare caseloads (i) occurred across demographic, health, education, and eligibility groups, (ii) were somewhat larger among young and healthier individuals, and (iii) were suggestively larger among persons less familiar with the programs. On the whole, I find limited change in the relative targeting of benefits.',
        links: [
            {
            title: 'Paper',
            url: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4811361'
            }
        ]
    },
        {
        title: 'Fertility Responses to Canada\'s Paid Parental Leave Expansion',
        authors: 'Jeffrey Hicks, Steven Ryan, Hugh Shiplett',
        date: 'April, 2026',
        journal: 'Revise & Resubmit, Economic Inquiry',
        abstract: 'Canada doubled paid and protected parental leave for parents of children born after December 30th, 2000, creating an eligibility cutoff that has been widely used as a quasi-experiment. We study fertility dynamics around this reform using new administrative data. The policy was announced 14 months in advance, allowing families to delay fertility. Consistent with this, we document an immediate reduction in conceptions after the announcement: in the latter half of 2000, births among benefit-eligible mothers were 8% lower than a predicted counterfactual, followed by a relative boom after implementation. Fertility responses were strongest near the cutoff, exhibiting a 25%-30% discontinuity in births among benefit claimants. Placebo checks support a causal interpretation. Timing responses were strongest among high-income mothers and higher-order births, where the discontinuity in births was up to 47%, consistent with financial incentives and salience. These patterns underscore the sensitivity of fertility timing to financial incentives and have implications for research that assumes no such responsiveness. We situate these short-run timing responses within the longer-run evolution of fertility following the expansion.',
        links: [
            {
                title: 'Paper',
                url: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=6622098'
            }    
        ]
    },
]

const publications = [
        {
        title: 'The Effect of Reducing Welfare Access on Employment, Health, and Children\'s Long-Run Outcomes',
        authors: 'Jeffrey Hicks (Co-Lead Author), Gaelle Simard-Duplain (Co-Lead Author), David Green, William Warburton',
        abstract: 'Welfare caseloads in North America halved following reforms in the 1990s and 2000s. We study how this shift affected families by linking Canadian welfare records to tax returns, medical care, educational attainment, and crime data. We find substantial and heterogeneous employment responses that increased average income despite reduced transfers. We find zero effects on aggregate healthcare costs, but mothers saw reduced preventative care and increased mental health treatment, consistent with the transition to employment elevating time pressure and stress. We find no effect on teenagers’ education or criminal charges as young adults but find some evidence of intergenerational welfare transmission.',
        date: 'October 2026',
        journal: 'The Economic Journal (Accepted)',
        citation: `@Article{Hicks2023,
            author    = {Hicks, Jeffrey and Simard-Duplain, Gaelle and Green, David and Warburton, William},
            journal   = {SSRN Electronic Journal},
            title     = {The Effect of Reducing Welfare Access on Employment, Health, and Children's Long-Run Outcomes},
            year      = {2026},
            doi       = {10.2139/ssrn.4147958},
            publisher = {Elsevier BV},
          }`,
        links: [
            {
                title: 'Paper',
                url: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4147958'
            }    
        ]
    },
        {
        title: 'The Spillover Effects of Top Income Inequality',
        authors: 'Joshua Gottlieb, David Hemous, Jeffrey Hicks, Morten Olsen',
        journal: 'Econometrica (Accepted)',
        date: '2026',
        abstract: 'Topincome inequality in the United States has increased considerably within many occupations. This phenomenon has led to a search for a common explanation. We instead develop a theory where increases in income inequality originating within a few occupations can“spill over”through consumption into others. We show theoretically that such spillovers occur when an occupation provides non-divisible services of heterogeneous quality to consumers. Examining local income inequality across U.S. regions, we find evidence that such spillovers exist for physicians, dentists, other medical occupations, and real estate agents. Estimated spillovers for other occupations are consistent with the predictions of our theory. Calibrating our model, we show that spillovers amplify a given shock to top income inequality by at least 16%. Spillovers dampen the increase in consumers’ welfare inequality compared with the change in income inequality.',
        citation: `@techreport{GottliebHemousHicksOlsen,
            title = "The Spillover Effects of Top Income Inequality",
            author = "Gottlieb, Joshua D and Hémous, David and Hicks, Jeffrey and Olsen, Morten G",
            institution = "National Bureau of Economic Research",
            type = "Working Paper",
            series = "Working Paper Series",
            number = "31366",
            year = "2026",
            month = "November",
            doi = {10.3386/w31366}
           }`,
        links: [
            {
                title: 'Paper',
                url: 'https://www.econ.uzh.ch/dam/jcr:299d2bce-be9a-407a-a8bc-67b8d5b47b40/The%20Spillover%20Effects%20of%20Top%20Income%20Inequality_November%202025.pdf'
            }
        ]
    },
    {
        title: 'Cash Welfare and Health Spending',
        authors: 'Jeffrey Hicks',
        journal: 'Journal of Human Resources (Accepted)',
        date: 'October 2025',
        abstract: 'I explore the interplay between cash welfare programs and health using Canadian administrative data. Health spending doubles before a welfare application, then partially returns to normal levels within three years. Using quasi-experimental variation in application adjudicators, I estimate that welfare receipt has, at most, minor positive effects on universally insured healthcare use. These findings imply that welfare insures against health risk without significantly affecting health outcomes. Welfare does substantially increase pharmaceutical use, which is not universally insured but for which welfare recipients are subsidized, implying that incomplete drug insurance strongly limits medication access among low-income households that cannot access welfare.',
        citation: `@Article{Hicks2023b,
            author    = {Hicks, Jeffrey},
            journal   = {SSRN Electronic Journal},
            title     = {Cash Welfare and Health Spending},
            year      = {2024},
            doi       = {10.2139/ssrn.4366181},
            publisher = {Elsevier BV},
          } `,
        links: [
            {
                title: 'Paper',
                url: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4366181'

            }
        ]
    },
            {
        title: 'International Comparison of Physician Incomes',
        authors: 'Aidan Buehler, Joshua Gottlieb, Jeffrey Hicks, Lisa Laun, Marten Palme, Maria Polyakova, Victoria Udalova, and Maria Ventura',
        journal: 'American Economic Association: Papers and Proceedings',
        date: 'May 2026',
        abstract: 'We compare physician earnings using tax data from the U.S., Canada, Sweden, and the Netherlands. Physicians are concentrated in the top few percentiles of the income distribution in all four countries, especially in the U.S. and in certain specialties. Physician incomes are highest in the U.S., and a decomposition shows that this mainly reflects differences in overall income distributions, rather than physicians\' locations in those distributions. This suggests that broader labor market differences, and thus physicians\' outside options, drive absolute earnings. Shifting U.S. physicians\' incomes to match relative positions in other countries\' distributions would have minimal impact on healthcare spending.',
        citation: `@article{GottliebP_P2026,
            title = {International Comparison of Physician Incomes},
            author = {Aidan Buehler and Joshua D. Gottlieb and Jeffrey Hicks and Lisa Laun and M\aa{}rten Palme and Maria Polyakova and Victoria Udalova and Maria Ventura},
            year = {2026},
            journal = {American Economic Association: Papers and Proceedings},
            month = {May},
            volume = {116}
        }`,
        links: [
            {
                title: 'Paper',
                url: 'https://www.gottlieb.ca/papers/DocIncP_P.pdf'
            }
        ]
    },
    {
        title: 'Administrative Procedures as Tax Enforcement Tools',
        authors: 'Wei Cui, Jeffrey Hicks, Michael Wiebe',
        date: '2024',
        journal: 'Economics Letters',
        abstract: 'We study how common administrative procedures affect firm tax evasion. We begin with the counter-intuitive observation that many firms bunch above, rather than below, large notches in China\’s corporate income tax. Cross-sectional patterns suggest that administrative procedures in the prepayment and refund system served as de facto enforcement tools that prevented some firms from accessing the reduced tax rates below the notches. Following a regulatory reform that eliminated these procedures, bunching below the notches increased dramatically. The results imply a trade-off between reducing administrative barriers and allowing much taxpayer non-compliance in low-compliance environments.',
        citation: `@article{CuiHicksWiebe,
            title = {Administrative procedures as tax enforcement tools},
            journal = {Economics Letters},
            volume = {237},
            pages = {111649},
            year = {2024},
            issn = {0165-1765},
            doi = {https://doi.org/10.1016/j.econlet.2024.111649},
            url = {https://www.sciencedirect.com/science/article/pii/S0165176524001320},
            author = {Wei Cui and Jeffrey Hicks and Michael Wiebe},
            keywords = {Tax administration, Evasion, Bunching},
            abstract = {We study how common administrative procedures affect firm tax evasion. We begin with the counter-intuitive observation that many firms bunch above, rather than below, large notches in China’s corporate income tax. Cross-sectional patterns suggest that administrative procedures in the prepayment and refund system served as de facto enforcement tools that prevented some firms from accessing the reduced tax rates below the notches. Following a regulatory reform that eliminated these procedures, bunching below the notches increased dramatically. The results imply a trade-off between reducing administrative barriers and allowing much taxpayer non-compliance in low-compliance environments.}
            }`,        
        links: [
            {
                title: 'Journal',
                url: 'https://www.sciencedirect.com/science/article/pii/S0165176524001320?via%3Dihub'
            },
            {
                title: 'Ungated',
                url: 'https://commons.allard.ubc.ca/fac_pubs/758/'
            },
        ]
    },
    {
        title: 'Cash on the Table? Imperfect Take-up of Tax Incentives and Firm Investment Behavior',
        authors: 'Wei Cui, Jeffrey Hicks, Jing Xing',
        journal: 'Journal of Public Economics',
        date: '2022',
        abstract: 'We investigate whether tax incentives are effective in stimulating private investment in less developed countries, by exploiting the introduction of accelerated depreciation for fixed assets investment in China as a natural experiment. In contrast to the large positive impact of similar tax incentives in the U.S. and U.K. found in recent studies, accelerated depreciation appeared ineffective in stimulating Chinese firms\' investment. Using confidential corporate tax returns from a large province, we find that firms fail to claim the tax benefits on over 80 percent of eligible investments. Firms\' take-up of the tax incentive is significantly influenced by their taxable positions and tax sophistication. Information transmission and resources of local tax authorities also play a significant role. Our study contributes to the understanding of conditions under which tax-based investment incentives can be effective.',
        citation: `@article{CuiHicksXing,
            title = {Cash on the table? Imperfect take-up of tax incentives and firm investment behavior},
            journal = {Journal of Public Economics},
            volume = {208},
            pages = {104632},
            year = {2022},
            issn = {0047-2727},
            doi = {https://doi.org/10.1016/j.jpubeco.2022.104632},
            url = {https://www.sciencedirect.com/science/article/pii/S0047272722000342},
            author = {Cui, Wei and Hicks, Jeffrey and Xing, Jing}
        }`, 
        links: [
            {
                title: 'Journal',
                url: 'https://www.sciencedirect.com/science/article/pii/S0047272722000342?dgcid=author'
            },
            {
                title: 'Paper',
                url: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3695120'
            },
            {
                title: 'Online Appendix',
                url: 'https://ars.els-cdn.com/content/image/1-s2.0-S0047272722000342-mmc1.pdf'
            },
            {
                title: 'Code',
                url: 'https://github.com/jeffhicks05/Code_Package_Cash_on_the_Table'
            }
        ]
    } ,
    {
        title: 'How Well-Targeted are Payroll Tax Cuts as a Response to COVID-19? Evidence from China',
        authors: 'Wei Cui, Jeffrey Hicks, Max Norton',
        journal: 'International Tax and Public Finance',
        date: '2022',
        abstract: 'Numerous countries cut payroll taxes in response to COVID-19, including China, which reduced employer contributions by up to 21 percentage points. We use administrative data on more than 800,000 Chinese firms to evaluate payroll tax cuts as a business relief measure. We estimate that the tax cuts cover 31.5% of the decline in business cash flow, but labor informality causes 53% of registered firms---24% of aggregate economic activity---to receive no benefits at all. We quantify the targeting of the policy in terms of how much benefits flow to small firms less able to access external finance and to sectors worse hit by COVID-19. We find that (1) small firms and vulnerable industries are comparatively more labor intensive, which leads to desirable targeting; (2) labor informality worsens, but does not eliminate, targeting by firm size; and (3) labor informality is uncorrelated with the COVID-19 shock, and therefore does not affect targeting by sector.',
        citation: `@article{CuiHicksNorton,
            title = {How Well-Targeted are Payroll Tax Cuts as a Response to COVID-19? Evidence from China},
            journal = {International Tax and Public Finance},
            year = {2022},
            volume = {29},
            number = {5},
            doi = {https://doi.org/10.1007/s10797-022-09746-w},
            url = {https://link.springer.com/article/10.1007/s10797-022-09746-w},
            author = {Cui, Wei and Hicks, Jeffrey and Norton, Max}
        }`, 
        links: [
            {
                title: 'Journal',
                url: 'https://link.springer.com/article/10.1007/s10797-022-09746-w'
            },
            {
                title: 'Paper',
                url: 'https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3686345'
            },
            {
               title: 'Online Appendix',
               url: 'https://static-content.springer.com/esm/art%3A10.1007%2Fs10797-022-09746-w/MediaObjects/10797_2022_9746_MOESM1_ESM.pdf' 
            },
            {
                title: 'Code',
                url: 'https://github.com/jeffhicks05/Code_repository_for_cui_hicks_norton_2022'
            }

        ]
    },
    {
        title: 'How Would Medicare for All Affect Health System Capacity? Evidence from Medicare for Some',
        authors: 'Jeffrey Clemens, Joshua Gottlieb, Jeffrey Hicks',
        journal: 'Tax Policy and the Economy',
        date: '2021',
        abstract: 'Proposals to create a national health care plan such as "Medicare for All" rely heavily on reducing the prices that insurers pay for health care. These changes affect physicians\' short-run incentives for care provision and may also change health care providers\' incentives to invest in capacity, thereby influencing the availability of care in the long term. We provide evidence on these responses using a major Medicare payment change combined with survey data on physicians\' time use. We find evidence that physicians increase their time spent on capacity building when remuneration increases, and that they are subsequently more willing to accept new patients—especially those who may be the residual claimants on marginal capacity. These forces imply that short-run supply curves likely differ from long-run supply curves. Policymakers need to account for how major changes to payment incentives would influence the investments that determine health system capacity.',
        citation: `@article{ClemensGottliebHicks,
            author = {Clemens, Jeffrey and Gottlieb, Joshua D. and Hicks, Jeffrey},
            title = {How Would Medicare for All Affect Health System Capacity? Evidence from Medicare for Some},
            journal = {Tax Policy and the Economy},
            volume = {35},
            number = {},
            pages = {225-262},
            year = {2021},
            doi = {10.1086/713497},
    url = {https://www.journals.uchicago.edu/doi/abs/10.1086/713497?journalCode=tpe}
}`,
        links: [
            {
                title: 'Journal',
                url: 'https://www.journals.uchicago.edu/doi/abs/10.1086/713497?journalCode=tpe'
            },
            {
                title: `Paper`,
                url: `https://www.nber.org/papers/w28062`    

            },
            {
                title: 'Online Appendix',
                url: 'https://users.nber.org/~jdgottl/ClemensGottliebHicksAppendix.pdf'
            },
            {
                title: 'Data and Code',
                url: 'https://github.com/jeffhicks05/Replication_Package_Clemens_Gottlieb_Hicks_2020'
            }
        ]
    }
   
]

const worksInProgress = [

]


const policyOutreach = [
    {
    title: 'BC Income Assistance Trends and Dynamics: Descriptions and Policy Implications',
    authors: 'David Green, Jeffrey Hicks, Rebecca Warburton, Bill Warburton',
    journal: 'Commissioned by the Expert Panel on Basic Income, British Columbia',
    date: '2021',
    abstract: 'This paper documents various features of B.C. Income Assistance (IA), including durations of spells of IA, how durations differ according to recipient case characteristics, and how durations and case characteristics have changed over time from February 1989 through December 2017, based on official B.C. administrative data. The goal of the paper is to relate these patterns to key policy questions, and so it is framed as a set of main patterns, each followed by a list of policy implications.',
    citation: `@article{GreenHicksWarburtons,
        author = {Green, David and Hicks, Jeffrey and Warburton, Rebecca and Warburton, William},
        title = {BC Income Assistance Trends and Dynamics: Descriptions and Policy Implications},
        journal = {Report commissioned by the Expert Panel on Basic Income},
        volume = {},
        number = {},
        pages = {},
        year = {2021},
url = {https://econ2017.sites.olt.ubc.ca/files/2021/03/BC-Income-Assistance-Trends-and-Dynamics-Descriptions-and-Policy-Implications_Green_Hicks_RWarburton_BWarburton1.pdf}
}`, 
    links: [
        {
            title: 'Journal',
            url: 'https://bcbasicincomepanel.ca/wp-content/uploads/2021/01/BC_Income_Assistance_Trends_and_Dynamics_Descriptions_and_Policy_Implications.pdf'
        }
    ]
    }
]

module.exports = { workingPapers, publications,policyOutreach, worksInProgress }

